var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('span',{staticClass:"label is-size-4"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"control"},[_c('label',{staticClass:"toggleSwitch"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function (ref) {
	var target = ref.target;

	return _vm.$emit('input', target.checked);
}}}),_c('span',[_c('span',[_vm._v(_vm._s(_vm.offText))]),_c('span',[_vm._v(_vm._s(_vm.onText))])]),_c('a')])])])}
var staticRenderFns = []

export { render, staticRenderFns }